import { Autocomplete, Box, Button, Chip, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { Days, Months, Weeks, Year } from "../../../../Utility/Constants";
import { debounce } from '../../../../Components/CommonFunctions/CommonFunctions'

const durationObj = {
    "days": Days,
    "weeks": Weeks,
    "months": Months,
    "years": Year,
}

class DocPastHistoryRight extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pastHistory: "",
            selectedDays: 'days',
            historySuggestLst: [],
            desSuggestLst: [],
            comments: "",
            isDisable: false,
            editId: null,
        }
        this.deBounceApiSrch = debounce(this.getPastHistorysuggestion, 500)
    }

    componentDidMount() {
        if(Object.keys(this.props.EditPastHistoryData).length !== 0){
            this.updateEditState();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.EditPastHistoryData !== this.props.EditPastHistoryData &&
            this.props.EditPastHistoryData &&
            Object.keys(this.props.EditPastHistoryData).length !== 0
        ) {
            this.updateEditState();
        }
    }

    updateEditState = () => {
        this.setState((prevState) => ({
            ...prevState,
            comments: this.props.EditPastHistoryData?.comments,
            pastHistory: this.props.EditPastHistoryData?.past_history || prevState?.pastHistory,
            selectedDuration: this.props.EditPastHistoryData?.duration || prevState?.selectedDuration,
            selectedDays: this.props.EditPastHistoryData?.duration_mode || prevState?.selectedDays,
            editId: this.props.EditPastHistoryData?.id || prevState?.editId,
        }), () => { this.props.ClearPropsData() })
    }

    getPastHistorysuggestion = (key, historyType) => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PAST_HISTORY_SUGGESTION + `?history_type=${historyType}&search_key=${key}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response.data.data?.length > 0 ? response.data.data : [];
                        this.setState({
                            ...(historyType === "suggestion" && { historySuggestLst: Data }),
                            ...(historyType === "comments" && { desSuggestLst: Data }),
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    onClearHandler = () => {
        this.setState({
            selectedDays: 'days',
            selectedDuration: '',
            pastHistory: null,
            historySuggestLst: [],
            editId: null,
        }, () => { this.props.CallgetApi('past_history')})
    }

    postPastHistory = () => {
        const { appointment_id, patient_id } = this.props.PatientData;
        const { pastHistory, selectedDays, selectedDuration, comments, editId } = this.state;
        try {
            const data = {
                "appointment_id": appointment_id,
                "patient_id": patient_id,
                "comments": comments,
                "past_history": (pastHistory || (selectedDuration && selectedDays)) ? [
                    {
                        'id': editId ? editId : null,
                        'past_history': pastHistory || "",
                        'duration': selectedDays ? selectedDuration || "" : "", // 10
                        'duration_mode': selectedDuration ? selectedDays : "", // days
                    }
                ] : []
            }
            RestAPIService.create(data, Serviceurls.DOC_PAST_HISTORY_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response?.data?.message)
                        this.onClearHandler()
                        this.setState({ isDisable: false })
                        this.props.CallgetApi('past_history')
                    }
                }).catch((error) => {
                    this.setState({ isDisable: false })
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })

        } catch (error) {
            this.setState({ isDisable: false })
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    renderAutoComplete = (label, statekey, listKey, maxlen, history_type, width = "20vw") => {
        const fieldId = `doc_past_history_right_${statekey}`
        return (<Autocomplete
            emed_tid={`${fieldId}_autocomplete`}
            size='small'
            sx={{ width: width }}
            clearIcon = {statekey !== "comments"}
            freeSolo
            options={this.state[listKey] || []}
            getOptionLabel={(options) => options}
            value={this.state[statekey] || ""}
            onChange={(e, newValue) => {
                this.setState({ [statekey]: newValue });
            }}
            renderInput={(params) => <TextField  {...params}
                emed_tid={`${fieldId}_textfield`}
                inputProps={{ ...params.inputProps, maxLength: maxlen, emed_tid: `${fieldId}_input` }}
                autoComplete='off'
                label={label}
                multiline={statekey === "comments"}
                rows={statekey === "comments" ? 3 : 1}
                onChange={(e) => {
                    const { value } = e.target;
                    if (value != "") {
                        this.setState({
                            [statekey]: value
                        }, () => { this.deBounceApiSrch(value, history_type) })
                    } else {
                        this.setState({ [listKey]: [] })
                    }
                }}
            />}
        />)
    }

    render() {
        const { t } = this.props
        const label = this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Past History';
        const {pastHistory, comments, isDisable, selectedDuration, selectedDays} = this.state;
        return (
            <Box emed_tid="doc_past_history_right_container">
                <Box height={"61.3vh"} emed_tid="doc_past_history_right_content">
                    <Typography className='eMed_refdoc_title' emed_tid="doc_past_history_right_title">{label}</Typography>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: "center", alignItems: 'center', marginX: "1vw", mt: "1.5vw", gap: "0.5vw" }} emed_tid="doc_past_history_right_fields">
                        {this.renderAutoComplete(label, "pastHistory", "historySuggestLst", 100, "suggestion")}
                        <Box component={'div'} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }} emed_tid="doc_past_history_right_duration_select_box">
                            <FormControl size='small' emed_tid="doc_past_history_right_duration_formcontrol">
                                <InputLabel emed_tid="doc_past_history_right_duration_label">Select Duration</InputLabel>
                                <Select
                                    emed_tid="doc_past_history_right_duration_select"
                                    sx={{ width: '10vw' }}
                                    label='Select Duration'
                                    value={this.state.selectedDays}
                                    onChange={(e) => this.setState({ selectedDays: e.target.value, selectedDuration: '' })}
                                >
                                    <MenuItem value={'days'} emed_tid="doc_past_history_right_duration_days">Days</MenuItem>
                                    <MenuItem value={'weeks'} emed_tid="doc_past_history_right_duration_weeks">Weeks</MenuItem>
                                    <MenuItem value={'months'} emed_tid="doc_past_history_right_duration_months">Months</MenuItem>
                                    <MenuItem value={'years'} emed_tid="doc_past_history_right_duration_years">Years</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box className="eMed_DocNotes_durChip_Wrapp" emed_tid="doc_past_history_right_chips_wrapper">
                        <Box component={'div'} mt={'1vw'} emed_tid="doc_past_history_right_chips_box">
                            <Typography sx={{ marginBottom: "0.7vh" }} fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid="doc_past_history_right_chips_title">Duration</Typography>
                            {this.state.selectedDays ?
                                durationObj[this.state.selectedDays]?.map((item, index) => (
                                    <Chip
                                        emed_tid={`doc_past_history_right_chip_${index}`}
                                        className={`eMed_chip ${item.value === this.state.selectedDuration ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={item.label}
                                        variant={item.value === this.state.selectedDuration ? 'contained' : 'outlined'}
                                        key={index}
                                        sx={{ marginLeft: '0.7vw' }}
                                        onClick={() => { this.setState({ selectedDuration: item?.value }) }}
                                        clickable
                                    />
                                )) : null}
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "center", alignItems: 'center', mt: "1.5vw", marginX: "1vw" }} emed_tid="doc_past_history_right_comments_box">
                        {this.renderAutoComplete('Description (Max 250 Characters)', "comments", "desSuggestLst", 250, "comments", "100%")}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} marginTop={"1vh"} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="doc_past_history_right_actions">
                    <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.onClearHandler() }} emed_tid="doc_past_history_right_clear_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" id="eMed_Config_btn" disabled={isDisable || (!pastHistory && !comments && !(selectedDuration && selectedDays))}
                        onClick={() => {
                            this.setState({ isDisable: true }, () => { this.postPastHistory() })
                        }} emed_tid="doc_past_history_right_add_btn">{t("Add")}</Button>
                </Stack>
                {this.state.isErrorMsg && <ToastMsg
                    emed_tid="doc_past_history_right_error_toast"
                    severity={'error'}
                    msg={this.state.isErrorMsgText}
                    msgPop={this.msgClose.bind(this)}
                />}
                {this.state.successMsg && <ToastMsg
                    emed_tid="doc_past_history_right_success_toast"
                    severity={'success'}
                    msg={this.state.successMsgText}
                    msgPop={this.msgClose.bind(this)}
                />}
            </Box>
        )
    }
}
export default withTranslation()(DocPastHistoryRight)